<div class="flex flex-col gap-1.5">
  @for (trend of trends; track trend.label) {
    <div class="grid grid-cols-[1.25rem_2rem_auto] items-center gap-x-1">
      <span
        class="flex h-5 w-5 items-center justify-center rounded-full"
        [class.bg-lSuccess]="trend.isPositive"
        [class.bg-lDanger]="!trend.isPositive"
      >
        <l-icon class="!text-base leading-none text-lGray900 light:text-white">
          {{ trend.isPositive ? 'arrow_upward' : 'arrow_downward' }}
        </l-icon>
      </span>

      <span class="text-xs font-medium tabular-nums text-lWhite">
        {{ trend.isPositive ? '+' : '-' }} {{ trend.percentage }}%
      </span>

      <span class="text-xs text-lSecondary">{{ trend.label }}</span>
    </div>
  }
</div>
